import React from 'react'

function Footer() {
    return (
        <div
        style={{width:'100%',padding:'0.5rem', height:'8vh', display:'flex', justifyContent:'center', alignItems:'center'}}
        >
            <p>Made by 👩‍💻 Harsh Kunte</p>
        </div>
    )
}

export default Footer
